
<layout-index>
  <template v-if="!uploadInstance.getSettings().readonly" v-slot:uploadContainer>
    <drop-file-input class="upload-box-container">
      <p class="upload-icon icon-inbox"></p>
      <p class="upload-text" v-html="uploadInstance.getConfig().explain"></p>
      <p class="upload-hint" v-html="uploadInstance.getSettings().tip"></p>
      <div class="upload-error-list pretty-scrollbar">
        <p class="error-info" v-for="(error, index) in renderData.errors" :key="index">
          {{ error }}
        </p>
      </div>
    </drop-file-input>
  </template>

  <template v-slot:listContainer>
    <TransitionGroup tag="div" name="fade" ref="listContainerRef" class="scroll-container pretty-scrollbar"
      v-on:mouseenter="renderData.scrollLock = true" v-on:mouseleave="renderData.scrollLock = false">
      <selected-file-info v-for="sortKey in renderData.selectedFileSortMapSize"
        v-bind:key="uploadInstance.getSelectedFileSortMap().get(sortKey)"
        :selectedFile="uploadInstance.getSelectedFile(sortKey)"
        :readyDrag="renderData.readyDraggingSortKey === sortKey"
        :startDrag="renderData.currentDraggingSortKey !== null"
        :dragging="renderData.currentDraggingSortKey === sortKey" :dragover="renderData.lastDraggingSortKey === sortKey &&
          renderData.currentDraggingSortKey !== sortKey
          " @setContainerRef="(el) => setContainerRef(sortKey, el)"
        @mouseDown="(event) => containerMouseDown(sortKey, event, false)"
        @mouseUp="(event) => containerMouseUp(sortKey, event, false)"
        @touchstart.native.prevent="(event) => containerMouseDown(sortKey, event, true)"
        @touchend.native.prevent="(event) => containerMouseUp(sortKey, event, true)"
        @touchcancel.native.prevent="(event) => containerMouseUp(sortKey, event, true)" v-slot="slotProps">
        <layout-info class="item-info-container" :slotProps="slotProps"></layout-info>
      </selected-file-info>
    </TransitionGroup>
  </template>
</layout-index>
